import { default as smsDeprecatedServiceName, SmsDeprecatedService } from '@agent/core/channel-digit/sms/sms-deprecated.service';
import { VisioService } from '@agent/core/channel-digit/visio/visio.service';
import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { SmsService } from '@contact/upgrade';

import ChatIadvize from './chat-iadvize/iadvize.module.ajs';
import Chat from './chat/chat.module.ajs';
import Chatbot from './chatbot/chatbot.module.ajs';
import Mail from './mail/mail.module.ajs';
import SocialNetwork from './social-network/social-network.module.ajs';
import Softphone from './softphone/softphone.module.ajs';
import Videoconference from './videoconference/videoconference.module.ajs';

export default module('contact.agent.core.channel-digit', [Chat, Chatbot, ChatIadvize, Mail, SocialNetwork, Softphone, Videoconference])
  .run([smsDeprecatedServiceName, () => {}])
  .service(smsDeprecatedServiceName, SmsDeprecatedService)
  // DOWNGRADED
  .factory('visioService', downgradeInjectable(VisioService) as any)
  .factory('smsService', downgradeInjectable(SmsService) as any).name;
